import { Box, Typography, CircularProgress } from '@mui/material';
import CarouselArticulos from './CarouselArticulos';
import { fetchAllBlogPosts } from './../components/wordpressUtils';
import { useEffect, useState } from 'react';


export default function BlogSection({ wpData }) {
   const [isLoadingArticles, setIsLoadingArticles] = useState(true);
    const [wordpressArticles, setWordpressArticles] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
          try {
            setIsLoadingArticles(true);
            const wpArticles = await fetchAllBlogPosts();
            setWordpressArticles(wpArticles);
          } catch (err) {
            console.error('Error al obtener artículos:', err);
          } finally {
            setIsLoadingArticles(false);
          }
        };
    
        fetchData();
      }, []);
  return (
    <Box sx={{
      backgroundColor: 'white',
      pb: { xs: 6, md: '25px' },
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      px: { xs: 2, md: 0 },
      mt: 10
    }}>
      {/* Carrusel con artículos de WordPress */}
      <Box sx={{
        backgroundColor: 'white',
        pb: 10,
        pt: 8,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        borderBottom: '1px solid #E0E0E0'
      }}>
        <Typography sx={{
          py: 4,
          color: '#0A6274',
          fontSize: { xs: '1.6rem', md: '2rem' },
          fontWeight: 600,
          textAlign: 'center'
        }}>
          Explora nuestros <b>últimos insights</b>
        </Typography>

        {isLoadingArticles ? (
          <Box sx={{ height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress color="primary" />
          </Box>
        ) : wordpressArticles.length > 0 ? (
          <CarouselArticulos wpData={wordpressArticles} />
        ) : (
          <Typography>No hay artículos disponibles</Typography>
        )}
      </Box>
    </Box>
  );
}